import './search-bar.component.scss';
import { buttonize } from '../../../utils/a11y.utils';

import { h } from 'preact';
import { useState } from 'preact/hooks';

import { useTranslation } from '../../../i18n';
import { IconClose } from '../../icons/icon-close';
import { IconSearch } from '../../icons/icon-search';

export const SearchBar = ({ onSearch, onClear, children }) => {
  const [query, setQuery] = useState('');
  const { t } = useTranslation();

  const handleSearch = () => {
    if (onSearch) {
      onSearch(query);
    }
  };

  const handleClear = () => {
    setQuery('');
    if (onClear) {
      onClear('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div class="single-header-bar">
      {children}
      <div id="shopify-section-single-gated-search-bar" class="shopify-section single-search-bar">
        <input
          id="contentQuery"
          aria-label={t('common.searchByTitle')}
          value={query}
          placeholder={t('common.searchByTitle')}
          onInput={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <div class="single-search-actions">
          <div
            id="contentQuerySearch"
            class="single-icon single-submit"
            {...buttonize(handleSearch, t('common.search'))}
          >
            <IconSearch />
          </div>

          <div
            id="contentQueryClear"
            class="single-icon single-submit"
            {...buttonize(handleClear, t('common.clear'))}
          >
            <IconClose />
          </div>
        </div>
      </div>
    </div>
  );
};
